import { useEffect, useRef } from 'react';
import { fieldType } from 'src/types/form';

type Props = {
    dataField: fieldType;
    onChange: (data: any) => void;
    value: string | null;
    errors?: any;
    type: string;
};

function TimeField(props: Props) {
    const { dataField, onChange, value, errors, type } = props;
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (dataField.default && type !== 'add_action_in_component') {
            onChange(dataField.default);
        }
    }, [dataField, type]);

    const formatTime = (time: string) => {
        return time.length === 5 ? time : time.padStart(5, '0');
    };

    const handleTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newTime = formatTime(event.target.value);
        onChange(newTime);
    };

    const handleContainerClick = () => {
        if (inputRef.current) {
            inputRef.current.showPicker();
        }
    };

    return (
        <div className={`${dataField.width} mb-5`}>
            <label className='flex flex-row justify-between text-sm font-medium leading-6 text-gray-900'>
                <span>{dataField.title}</span>
                {dataField.require && (
                    <div className='flex flex-row justify-between'>
                        {Object.keys(errors).length > 0 && errors[dataField.key] && <span className='text-[#BA0C2F]'>Заполните поле&nbsp;</span>}
                        <span className='text-[#BA0C2F]'>*</span>
                    </div>
                )}
            </label>
            <div className='mt-2 relative cursor-pointer' onClick={handleContainerClick}>
                <input
                    ref={inputRef}
                    type='time'
                    className='text-left block w-full text-base rounded-lg border border-[#DFE4EA] py-3 px-5 text-black outline-none disabled:text-[#6B7280] disabled:bg-[#E5E7EB] cursor-pointer'
                    value={value || dataField.default || ''}
                    onChange={handleTimeChange}
                    disabled={dataField.disabled}
                    placeholder={dataField.placeholder}
                />
            </div>
        </div>
    );
}

export default TimeField;
